import { render } from "./NAlertBadge.vue?vue&type=template&id=c99b99be&ts=true"
import script from "./NAlertBadge.vue?vue&type=script&lang=ts"
export * from "./NAlertBadge.vue?vue&type=script&lang=ts"

import "./NAlertBadge.vue?vue&type=style&index=0&id=c99b99be&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__